module.exports = __webpack_public_path__ + "static/banner-started-813c470375d2b4ef3f5e60fc0c8d073a.png";